import {
    CYBERSOURCE_INIT_SUCCEEDED,
    CYBERSOURCE_CARDINAL_INIT_SUCCEEDED,
    CYBERSOURCE_SET_SUBMITTING
} from '../constants/action-types';

export const cyberSourceInitSucceeded = initData => ({
    type: CYBERSOURCE_INIT_SUCCEEDED,
    payload: initData
});

export const cyberSourceCardinalInitSucceeded = cardinalSessionId => ({
    type: CYBERSOURCE_CARDINAL_INIT_SUCCEEDED,
    payload: cardinalSessionId
});

export const cyberSourceSetSubmitting = isSubmitting => ({
    type: CYBERSOURCE_SET_SUBMITTING,
    payload: isSubmitting
});
